import styled from "styled-components";
import { useSelector } from "react-redux";

import { CirclePlusIcon, EnterpriseApplicationCirclePlusIcon, PersonPlusIcon } from "../modal/modalIcons";
import { getWindowWidth } from "../../../features/basic/reducers/basicReducer";
import { PrimaryButton } from "../../../styles/basicComponents";
import { useTheme } from "../../../features/context/CustomerContext";

const Card = styled.div`
    display: grid;
    width: 321px;
    height: 366px;
    background-color: #F4F5F5;
    border-radius: 10px;
`
const ImageDiv = styled.div`
`

const InfoText = styled.div`
    text-align: left;
    margin-left: 51px;
    margin-right: 51px;
    height: 80px;
    margin-top: -100px;
`
const InfoTextWithSecondLine = styled.div`
    text-align: left;
    margin-left: 51px;
    margin-right: 51px;
    height: 80px;
`
const InfoTextSecondLine = styled.div`
    text-align: left;
    margin-left: 51px;
    margin-right: 51px;
    padding-top: 20px;
    padding-bottom: 20px;
    @media screen and (min-width: ${props => props.theme.mobileTableBreakPoint}px) and (max-width:  ${props => props.theme.mobileMenuBreakpoint}px){
        position: relative;
        bottom: 51px;
    }
`

const Title = styled.h3`
    color: ${props => props.theme.brandColor1};
    height: 70px;
    margin-bottom: 0px;
    margin-top: 35px;
`

const MobileTitle = styled.h3`
    display: block;
    font-size: 16px;
    font-weight: 600;
    margin: 10px 0;
`
const MobileButton = styled(PrimaryButton)`
    max-width: 460px;
	display: block;
    margin: 24px 0 !important;
	width: 100%;
	text-align: left;
    height: auto;
    > path {
        fill: ${props => props.theme.brandColor1}
    }
`

const ButtonTextContainer = styled.div`
	margin: auto;
    width: fit-content;
    `

const MobileInfoText = styled.div`
    font-family: Arial;
    font-weight: 400;
    display: block;
    font-size: 12px;
    margin-bottom: 20px;
`
const MobileInfoTextWithSecondLine = styled.div`
    font-family: Arial;
    font-weight: 400;
    display: block;
    font-size: 12px;
    margin-bottom: 5px;

`
const MobileInfoTextSecondLine = styled.div`
    font-family: Arial;
    font-weight: 400;
    display: block;
    font-size: 12px;
    margin-bottom: 20px;
`

export interface ApplicationTypeCardProps {
    cardTitle: string;
    infoText: string;
    infoTextSecondPart?: string;
    enterpriseApplication: boolean;
}

const ApplicationTypeCard: React.FC<ApplicationTypeCardProps> = (props) => {
    const windowWidth = useSelector(getWindowWidth);

    const theme = useTheme();

    if (windowWidth <= theme.mobileTableBreakPoint) {
        return (
            <MobileButton theme={theme}>
                <ButtonTextContainer>
                    <MobileTitle>{props.cardTitle}</MobileTitle>
                    {props.infoTextSecondPart ?
                        <>
                            <MobileInfoTextWithSecondLine>{props.infoText}</MobileInfoTextWithSecondLine>
                            <MobileInfoTextSecondLine>{props.infoTextSecondPart}</MobileInfoTextSecondLine>
                        </>
                        :
                        <MobileInfoText>{props.infoText}</MobileInfoText>}

                </ButtonTextContainer>
            </MobileButton>
        )
    }

    return (
        <Card>
            <Title theme={theme}>{props.cardTitle}</Title>
            <ImageDiv>
                {props.enterpriseApplication ? props.infoTextSecondPart ? <CirclePlusIcon theme={theme} /> : <EnterpriseApplicationCirclePlusIcon theme={theme} /> : <PersonPlusIcon theme={theme} />}
            </ImageDiv>
            {props.infoTextSecondPart ?
                <>
                    <InfoTextWithSecondLine>{props.infoText}</InfoTextWithSecondLine>
                    <InfoTextSecondLine theme={theme}>{props.infoTextSecondPart}</InfoTextSecondLine>
                </>
                :
                <InfoText>{props.infoText}</InfoText>
            }
        </Card>
    )
}

export default ApplicationTypeCard